import React from "react";
import { ReactComponent as IconProdeseg } from "../../assets/img/logo/prodeseg-icon.svg";
import { ReactComponent as IconProdesegText } from "../../assets/img/logo/prodeseg-icon-text.svg";
import "./prodeseg-navbar.scss";
import { ProdesegUserProfile } from "./ProdesegUserProfile";
import { ProdesegNavbarMenu } from "./ProdesegNavbarMenu";
import { LinkUnset } from "../LinkUnset";
import { HOME_PATH } from "./navbar.constants";

export const ProdesegNavbar: React.FC = () => {
    return (
        <div
            className={`d-flex prodeseg-navbar shadow-sm align-items-end px-4 px-md-4-2 px-lg-4-3 px-xl-5  
            bg-gradient-linear-primary-1 justify-content-between`}
        >
            <div className={"pr-4-2 pr-sm-5 pr-md-5-4 pr-lg-5-5 pb-2-1 pb-lg-3-1 pb-xxl-4"}>
                <LinkUnset
                    to={HOME_PATH}
                    className="cursor-pointer d-flex align-items-baseline justify-content-start gap-2"
                >
                    <IconProdeseg className={"svg-white logo-prodeseg-icon"} />
                    <IconProdesegText className={"svg-neutral-500 d-none d-sm-block logo-prodeseg-text"} />
                </LinkUnset>
            </div>
            <div className={"d-flex gap-4 align-items-end align-items-md-center align-self-center"}>
                <ProdesegUserProfile />
                <ProdesegNavbarMenu />
            </div>
        </div>
    );
};
